import { useEffect } from 'react'
import { writeLogItems } from '../../store/log/actions'
import { useAppDispatch } from '../../store/types'

const Logger = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    setInterval(() => {
      dispatch(writeLogItems())
    }, 60000)
  }, [])
  return <></>
}

export default Logger
